export const CASES = {
    UPDATE_DATE_MATH_CALCULATIONS: 'UPDATE_DATE_MATH_CALCULATIONS',
    UPDATE_DATE_MATH_CALCULATIONS_SEARCH_FORM: 'UPDATE_DATE_MATH_CALCULATIONS_SEARCH_FORM',
    CLEAR_DATE_MATH_CALCULATIONS: 'CLEAR_DATE_MATH_CALCULATIONS',
};
